import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./onboarding/tour-styles.css";
import App from "./App.tsx";
import ErrorFallback from "./components/ErrorFallback.tsx";
import { registerServiceWorker } from "./pwa/registerSW.ts";
import { filtriSentry } from "./lib/riservato.ts";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    // il token del link per l'amministratore apre bollette intere: fuori da eventi e briciole
    ...filtriSentry,
  });
}

registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
